/**
 * CR V3 Web 观众公开 HTTP API（无需登录）
 */

import { request } from '@/shared/api/request'

/** join-info targetLanguages 项（D9/D12：短码 + BCP 双字段） */
export interface CrV3JoinTargetLanguage {
  languageCode: string
  languageCode2: string
  languageName?: string
  languageEnName?: string
}

export interface CrV3JoinInfo {
  workId: string
  meetingCode: string
  status: string
  remainingSlots: number
  maxMeetingParticipants: number
  courseName?: string
  hostName?: string
  wsUrl: string
  targetLanguages?: CrV3JoinTargetLanguage[]
}

export interface CrV3WsTokenData {
  token: string
  wsUrl: string
  expiresIn: number
  workId: string
  roleHint: string
}

export interface CrV3RuntimeConfigPublic {
  maxConcurrentMeetings?: number
  maxMeetingParticipants?: number
  segmentationSilenceTimeoutMs?: number
  ttsPlaybackRate?: number
  pcmChunkIntervalMs?: number
  partialLiveSpeechEnabled?: boolean
  version?: number
}

/** 词汇表项（L1 unwrap 后） */
export interface CrV3GlossaryItem {
  id: number
  langCode: string
  originalText: string
  translatedText: string
}

/** 匿名 join-info（不附带 JWT，避免与观众路径冲突） */
export function fetchJoinInfo(meetingCode: string): Promise<CrV3JoinInfo> {
  return request({
    url: `/cr_v3/meeting/${encodeURIComponent(meetingCode)}/join-info`,
    method: 'get',
    skipAuth: true,
    skipErrorToast: true,
  })
}

/** 匿名 ws-token */
export function fetchWsToken(meetingCode: string): Promise<CrV3WsTokenData> {
  return request({
    url: '/cr_v3/ws-token',
    method: 'get',
    params: { meetingCode },
    skipAuth: true,
  })
}

/** 各端入会拉取运行时参数（含 ttsPlaybackRate）；可选 workId 读本场快照 */
export function fetchRuntimeConfig(workId?: string): Promise<CrV3RuntimeConfigPublic> {
  return request({
    url: '/cr_v3/runtime-config',
    method: 'get',
    params: workId ? { workId } : undefined,
    skipAuth: true,
  })
}

/** 匿名 H5/参会端：按 meetingCode 拉术语（须 joinable 会议，D19） */
export function fetchGlossaryList(
  meetingCode: string,
  langCode?: string,
): Promise<CrV3GlossaryItem[]> {
  return request({
    url: '/cr_v3/speech/glossary/list',
    method: 'get',
    params: {
      meetingCode,
      ...(langCode ? { langCode } : {}),
    },
    skipAuth: true,
    skipErrorToast: true,
  })
}
